module.exports = __webpack_public_path__ + "media/images/smart_phone/topic_4-fa6ababd07335faf14cc79e9ea3bb5a6.png";